<template>
  <Btn :label="label" :disabled="disabled" isCheckRole @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnImport',

  components: {
    Btn,
  },

  props: {
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0080')
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
